import { render } from "./MaximizeIcon.vue?vue&type=template&id=2bbcb568"
import script from "./MaximizeIcon.vue?vue&type=script&lang=js"
export * from "./MaximizeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__